/* eslint-disable import/first */
import React from 'react'
import videojs from 'video.js';
window.videojs = videojs;
import "videojs-contrib-ads";
import '@videojs/http-streaming';
require('./ima/videojs.ima.js')
import 'video.js/dist/video-js.css'
import './lib/videojs.ima.css'
import _ from 'lodash'
import Cookies from 'js-cookie'
import { getVideo, getVideoSignature } from '~/redux/video/helpers'
import { saveWatchHistory } from '~/redux/uservideo/helpers'
import VideoJSBeacon from '~/tools/analytics/beacon/video'
import extract from "~/tools/extractDomain";
import getEnvironment from '~/tools/userEnvironment/codeEnvironment'
import browser from '~/tools/userEnvironment/browser'
import Embed from './screens/Embed'
import RatingDiscretion from './screens/rating'
import NextVideoTimer from './screens/nextVideoTimer'
import VideoWall from './screens/videoWall'
import { trackEvent, getPlaySourcePrefix } from '~/tools/analytics/cleverTap'
import definePricingMap from '~/tools/definePricingMap'
import { fetchModels } from '~/redux/models/helpers'

class VideoJS extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      video: null,
      startedAtSetTime: false,
      ratingDisplayDone: !this.isRatingEnabled(),
      showRatingDiscretion: false,
      videoWall: false,
      videoEnded: false,
      showEmbed: false,
    }
    // used to skip corrupt hls streams at the video start
    this.bufferedPercent = 0
    this.playStarted = false
    this.lastBufferedTime = 0
    this.totalBufferTime = 0
    this.bufferCount = 0
    this.streamedData = []

    this.toggleRatingDiscretion = this.toggleRatingDiscretion.bind(this)
    this.toggleEmbed = this.toggleEmbed.bind(this)
    this.handlePreviewSettings()

    if (props.video && props.video.tags) {
      this.tags = props.video.tags.map(t => t && t.title).join(',')
    }

    if (props.video && props.video.categories) {
      this.categories = props.video.categories.map(c => c && c.title).join(',')
    }
  }

  handlePreviewSettings() {
    const previewSettings = _.get(window.settings, 'features.free_preview')
    if (!previewSettings)
      return

    const showPreview = previewSettings.isFreePreview
    this.previewshowUnit = previewSettings.length.unit
    const previewShowTime =
      (this.previewshowUnit === "Minutes")
        ? parseInt(previewSettings.length.multiplier, 10) * 60
        : parseInt(previewSettings.length.multiplier, 10)
    this.previewTime = showPreview && previewShowTime
    this.perVideo = showPreview && previewSettings.per_video
  }

  async componentWillReceiveProps(nextProps, prevState) {
    const { video: { currentEpisode, currentSeason, showData: { seasons } = {} } } = nextProps
    const episode = (seasons && seasons[currentSeason].episodes[currentEpisode]) || {}
    this.hasAccess = definePricingMap(nextProps, episode, this.state.model)

    if (this.props.user === null && this.hasAccess && this.player != null) {
      this.setState({ videoWall: false })
      // this.player.play()
    }


    if (nextProps && (nextProps.isEpisode || nextProps.isPlaylistItem) && this.props.video.gist.id !== nextProps.video.gist.id && this.player != null) {
      let videoWall = false;
      if (!nextProps.video.gist.free && !this.previewTime && !this.hasAccess) {
        videoWall = true
        this.player.pause()
      }
      this.setState({ video: nextProps.video, videoEnded: false, videoWall: videoWall })
      if (videoWall) return
      this.playStarted = false
      this.streamedData = []
      if (this.interval) clearInterval(this.interval)
      const isHls = this.props.fileType === 'hls'
      let videoAssets = null;
      let src = null;

      if (isHls) {
        videoAssets = await this.fetchVideoSources(nextProps.video.gist.id);
        src = videoAssets.src;
      }
      else {
        videoAssets = (nextProps.video.streamingInfo || {}).videoAssets
        src = videoAssets && videoAssets.mpeg[0].url;
      }

      // reset player to prevent firefox from crashing
      this.player.reset()
      this.player.src(src)
      this.player.load()

      // update text track for video player
      // this.updateCaptions(captions)

      // update resolution control on mp4
      if (!isHls) {
        this.player.tech_.options_.source.src = src
        this.addResolutionControl(this.player, nextProps.fileType, videoAssets, this.state.isLiveStream)
      }

      this.player.play()
    }
  }

  getSignature() {
    return this.props.fileType === 'mp4'
      ? Promise.resolve()
      : getVideoSignature(this.props.videoId)
  }


  fetchVideoSources(id) {
    if (this.props.src) return Promise.resolve({ src: this.props.src, type: 'video/mp4' })
    if (!id) return Promise.reject('No Video Src or Video ID Not found')
    return getVideo(id, response => {
      const domain = extract(window.location.hostname)
      const expiresIn = new Date(new Date().getTime() + response.data.expireTime * 1000);
      Cookies.set(
        "CloudFront-Key-Pair-Id",
        response.data["CloudFront-Key-Pair-Id"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      Cookies.set(
        "CloudFront-Policy",
        response.data["CloudFront-Policy"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      Cookies.set(
        "CloudFront-Signature",
        response.data["CloudFront-Signature"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      var streamingInfo = response.data.video.streamingInfo
      this.assets = streamingInfo.videoAssets
      this.setState({
        isLiveStream: streamingInfo.isLiveStream,
        isFree: _.get(response, 'data.video.gist.free'),
        video: _.get(response, 'data.video'),
        gist: _.get(response, 'data.video.gist'),
        poster: response.data.video.gist.videoImageUrl
      })
      if (this.previewshowUnit === 'Videos' && !this.state.isFree) {
        let current = parseInt(Cookies.get('len'), 10)
        Cookies.set('len', (current || 0) + 1)
      }

      var hlsAssets = _.get(this.assets, 'hls')
      var mpegAssets = _.get(this.assets, 'mpeg[0].url')
      // if appcms is set to hls, try to load hls. Hls may not exist, but mp4 always does.
      // therefore, default to mp4.

      if (this.props.fileType === 'hls' && hlsAssets) {
        if (window.settings.internalName === 'snagfilms' || !hlsAssets.includes("viewlift.com")) {
          if (hlsAssets.includes("hoichoi.tv") || hlsAssets.includes("supercrosslive.tv")) {
            return { src: hlsAssets, type: 'application/x-mpegURL', withCredentials: true, overrideNative: true }
          } else if (window.settings.internalName === 'kronon') {
            return { src: hlsAssets, type: 'application/x-mpegURL', handleManifestRedirects: true }
          } else {
            return { src: hlsAssets, type: 'application/x-mpegURL' }
          }
        } else {
          return { src: hlsAssets, type: 'application/x-mpegURL', withCredentials: true, overrideNative: true }
        }
      } else {
        return { src: mpegAssets, type: 'video/mp4' }
      }
    })
  }

  async componentDidMount() {
    this.setState({ model: await fetchModels() })
    if (!this.props.isTrailer) {
      const { video: { currentEpisode, currentSeason, purchasedFlag, showData: { seasons } = {} } } = this.props
      const episode = (seasons && seasons[currentSeason].episodes[currentEpisode]) || {}
      this.hasAccess = definePricingMap(this.props, episode, this.state.model)
      if (!this.previewTime && !this.props.isFree && !this.hasAccess && !purchasedFlag && !this.props.purchased) {
        this.setState({ videoWall: true })
        return
      }
    }
    var autoplaySupport;

    let autoplayModule = await import("./ima/autoplay");

    if(window.SERVER_SIDE_RENDERING){
      //Cannot check autoplay on SSR
      return;
    }

    autoplayModule.getAutoplaySupport().then(
      (result) => {
        autoplaySupport = result;
        return this.fetchVideoSources(this.props.videoId)
      }
    ).then(sources => {


      const autoplay = autoplaySupport.autoplayAllowed;
      const muted = autoplaySupport.autoplayRequiresMute;

      let options = {
        controls: true,
        autoplay: (this.props.autoplay && autoplay) || false,
        muted: muted,
        preload: true,
        poster: this.state.poster,
        sources: [sources],
        debug: true
      };
      if (this.props.customControls) {
        options.controlBar = this.props.customControls;
      }


      let skin = "./skin";
      if (this.props.customSkin) {
        skin = this.props.customSkin
      }

      import(`${skin}.js`).then(({
        replaceIcons,
        addRewindControl,
        customizeCaptions,
        addResolutionControl,
        addEmbedBtn
      }) => {
        this.addResolutionControl = addResolutionControl;
        this.initializePlayer(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn);
      });

    }).catch(error => {
      if (error && error.errorMessage && error.errorMessage.includes('valid subscription')) {
        this.setState({
          videoWall: true
        })
        return
      }
      this.setState({ errorMessage: error.errorMessage || error.message })
    })
  }

  initializePlayer(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn) {
    this.player = videojs(this.videoNode, options, () => {
      replaceIcons(this.player)
      addRewindControl(this.player)
      let captions = this.props.closedCaptions || _.get(this.props, 'video.contentDetails.closedCaptions')
      if (_.some(captions, { format: 'VTT' }))
        customizeCaptions(this.player)


      addResolutionControl(this.player, this.props.fileType, this.assets, this.state.isLiveStream)

      window.settings.features && window.settings.features.embed_player && addEmbedBtn(this.player, this.toggleEmbed);
      this.props.showTimer && this.appendRemainingContainer(this.player, this.props.showTimer)
      if (this.props.autoplay && !browser.isMobile() && !browser.isSafari())
        this.startVideo()
    })

    window.player = this.player;


    const { video } = this.props
    this.beacon = new VideoJSBeacon({
      player: this.player,
      videoTitle: _.get(this.props, 'video.gist.title'),
      videoId: this.props.videoId,
      seriesTitle: _.get(this.props, 'seriesInfo.title'),
      seriesId: _.get(this.props, 'seriesInfo.id'),
      ...(video && {
        contentCategory: _.get(video.gist, 'primaryCategory.title'),
        isLiveStream: _.get(video.gist, 'isLiveStream')
      }),
      fileType: this.props.fileType,
      assets: this.assets,
      siteName: window.settings.internalName,
      clientId: window.settings.siteId,
      platform: 'WEBSITE',
      userId: this.props.user && this.props.user.userId,
      apiUrl: window.settings.beacon.apiBaseUrl,
      environment: getEnvironment()
    })

    this.listenToPlayerEvents()
    if (
      (typeof (window.google) !== 'undefined') &&
      this.props.videoTag &&
      !(this.props.user && this.props.user.isSubscribed) &&
      !this.props.hideAds &&
      !this.state.isLiveStream) {
      this.initializeAds()
    }
  }

  appendRemainingContainer(player, container) {
    player.el_.append(container)
  }

  getRemainingTime(time) {
    let minutes = Math.floor(time / 60)
    let seconds = Math.floor(time - minutes * 60)
    const wrapper = document.querySelector('.remaining-time-wrapper')
    wrapper && (wrapper.style.visibility = 'visible')
    const remainingTimeContainer = document.querySelector('.time-elapsed')
    remainingTimeContainer && (remainingTimeContainer.innerHTML = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`)
  }

  toggleEmbed() {
    this.setState({
      showEmbed: !(this.state.showEmbed)
    })
  }

  listenToPlayerEvents() {
    this.player.one(browser.isMobile() ? 'touchend' : 'click', _ => {
      // if (browser.isMobile() || browser.isSafari() || !this.state.ratingDisplayDone || !this.props.autoplay)
      this.startVideo()
    })

    this.player.one('loadeddata', () => {
      if (!isFinite(this.player.duration())) {
        document.getElementsByClassName('VideoJS')[0].classList.add('live')
      }
      if (this.props.startTime) {
        this.player.currentTime(this.props.startTime)
      }
    })

    this.player.on('firstplay', (e) => {
      if (!this.playStarted && this.state.video) {
        var { gist = {}, creditBlocks = [], categories = [] } = this.state.video
        categories.push(gist.primaryCategory || {})
        this.videoEventData = {
          contentId: gist.id,
          contentTitle: gist.title,
          contentType: gist.isTrailer ? 'Trailer' : gist.mediaType === 'EPISODIC' ? 'Episode' : 'Video',
          contentDuration: gist.runtime,
          playbackType: 'Streamed'
        }
        if (gist.mediaType === 'EPISODIC' && this.props.video && this.props.video.showData) {
          creditBlocks = this.props.video.showData.creditBlocks
          categories = this.props.video.showData.categories
          categories.push(this.props.video.showData.gist.primaryCategory || {})
          this.videoEventData = _.extend({}, this.videoEventData, {
            episodeNumber: this.props.video.currentEpisode + 1,
            seasonNumber: this.props.video.currentSeason + 1,
            showName: this.props.video.showData.gist.title
          })
        }
        this.videoEventData.playSource = getPlaySourcePrefix() + (this.props.video && this.props.video.showData ? '_Show Detail' : '_Video Detail')
        _.each(creditBlocks, creditBlock => {
          if (creditBlock.title.trim().toLowerCase() === 'director')
            this.videoEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
          if (creditBlock.title.trim().toLowerCase() === 'starring')
            this.videoEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        })
        this.videoEventData.contentGenre = categories.map(category => category.title).join(',')
        trackEvent('Play Started', this.videoEventData)
        this.playStarted = true
      }
    })

    var pingTimes = [], playedTime = []
    this.player.on('timeupdate', event => {
      var time = Math.floor(this.player.currentTime())
      this.props.showTimer && this.getRemainingTime(
        this.props.isLive ? (this.props.scheduleEndDate - Date.now()) / 1000 :
          this.player.remainingTimeDisplay()
      )
      if (!_.includes(playedTime, time)) {
        playedTime.push(time)

        this.sendWatchedEventData(time, this.player.duration())
        if (window.settings.serviceType === 'SVOD' && (!isFinite(this.player.duration()) || !this.perVideo) && !this.state.isFree && (this.previewshowUnit !== 'Videos') && this.previewTime) {
          Cookies.set('hdbm', parseInt(Cookies.get('hdbm') || 0, 10) + 1)
          time = parseInt(Cookies.get('hdbm'), 10)
        }
        if (window.settings.serviceType === 'SVOD' && this.previewshowUnit === 'Videos' && !this.state.isFree) {
          time = parseInt(Cookies.get('len'), 10)
        }

        if (
          (window.settings.serviceType === 'SVOD' || this.props.pricingOptions.type === 'SVOD') &&
          (time >= this.previewTime) && !this.state.isFree &&
          !(this.props.user && this.props.user.isSubscribed)
        ) {
          if (!this.props.purchased && this.props.pricingOptions && !this.props.pricingOptions.purchase && !this.props.pricingOptions.rent) {
            this.setState({ videoWall: true });
            this.player.pause();
            this.player.exitFullscreen();
          }
        }
        if (time >= 30 &&
          time % 30 === 0 &&
          !_.includes(pingTimes, time) &&
          !this.props.isTrailer && isFinite(this.player.duration())) {
          pingTimes.push(time)
          var duration = Math.floor(this.player.duration())
          this.sendWatchedInfo(time, duration)
        }
      }
    })

    this.player.on('waiting', event => {
      this.bufferCount += 1
      const offset = 0.1
      let lastVideoPosition = this.player.currentTime()

      let bufferingTimer = setInterval(() => {
        if (
          (this.player.currentTime() <= (lastVideoPosition + offset)) &&
          !this.player.paused()) {
          this.totalBufferTime = this.totalBufferTime + 0.1
        } else {
          clearInterval(bufferingTimer)
        }
      }, 100)
    })

    this.player.on('ended', event => {
      if (this.props.isPlaylistItem)
        this.setState({ videoEnded: true })

      if (this.props.isEpisode && this.props.video.nextEpisode)
        this.setState({ videoEnded: true })

      const relatedVideos = _.get(this.props, 'video.contentDetails.relatedVideoIds')
      if (!relatedVideos || relatedVideos.length === 0)
        return
      if (!window.settings.features['auto_play'])
        return
      if (this.props.isEpisode)
        return
      if (this.props.isPlaylistItem)
        return

      let current = window.sessionStorage.getItem('rvid') !== null
        ? parseInt(window.sessionStorage.getItem('rvid'), 10) + 1
        : 0
      window.sessionStorage.setItem('rvid', current)
      getVideo(relatedVideos[current], response => {
        window.location.href = response.data.video.gist.permalink
      })
    })

    this.player.on('error', event => {
      var playErrorEventData = {}
      if (this.videoEventData) {
        _.assignIn(playErrorEventData, this.videoEventData)
      }
      playErrorEventData.errorMessage = this.player.error().message;
      trackEvent('Media Error', playErrorEventData)
    })

    this.player.on('ready', event => {
      let captions = _.filter(this.props.closedCaptions || _.get(this.props, 'video.contentDetails.closedCaptions'), { format: 'VTT' });
      this.updateCaptions(captions);
    });
  }

  refreshPlayer() {
    if (this.player.currentTime() === this.bufferedPercent) {
      this.bufferedPercent++;
      this.player.currentTime(this.bufferedPercent)
    } else {
      clearInterval(this.refresh)
    }
  }

  sendWatchedInfo(time, duration) {
    saveWatchHistory({
      videoId: this.props.videoId,
      watchedTime: time,
      watchedPercentage: Math.floor((time / duration) * 100),
      siteOwner: window.settings.internalName,
      userId: this.props.user && this.props.user.userId
    })
  }

  sendWatchedEventData(time, duration) {
    if (this.videoEventData) {
      var pushWatchedEvent = false
      var streamedPercent = Math.floor((time / duration) * 100)
      var watchedEventData = _.extend({}, this.videoEventData)
      if (time >= 120 && streamedPercent < 25 && this.streamedData.indexOf('2 mins') === -1) {
        this.streamedData.push('2 mins')
        pushWatchedEvent = true
      } else if (streamedPercent >= 25 && streamedPercent < 50 && this.streamedData.indexOf(25) === -1) {
        this.streamedData.push(25)
        pushWatchedEvent = true
      } else if (streamedPercent >= 50 && streamedPercent < 75 && this.streamedData.indexOf(50) === -1) {
        this.streamedData.push(50)
        pushWatchedEvent = true
      } else if (streamedPercent >= 75 && streamedPercent < 80 && this.streamedData.indexOf(75) === -1) {
        this.streamedData.push(75)
        pushWatchedEvent = true
      } else if (streamedPercent >= 80 && this.streamedData.indexOf(80) === -1) {
        this.streamedData.push(80)
        pushWatchedEvent = true
      }
      if (pushWatchedEvent) {
        var captions = _.filter(this.props.closedCaptions || _.get(this.props, 'video.contentDetails.closedCaptions'), { format: 'VTT' })
        watchedEventData.subtitles = captions.length ? 'Y' : 'N'
        watchedEventData.stream = this.streamedData[this.streamedData.length - 1]
        watchedEventData.bufferTime = _.round(this.totalBufferTime)
        watchedEventData.bufferCount = this.bufferCount
        watchedEventData.watchedTime = _.round(time - this.lastBufferedTime)
        if (watchedEventData.playSource) delete watchedEventData.playSource
        trackEvent('Watched', watchedEventData)
        this.lastBufferedTime = time
        this.totalBufferTime = 0
        this.bufferCount = 0
      }
    }
  }

  startVideo() {
    var showAds =
      this.props.videoTag &&
      !this.props.hideAds &&
      !this.state.isLiveStream

    if (!showAds && !(this.props.user && this.props.user.isSubscribed)) {

      this.player.ima.initializeAdDisplayContainer()
      this.toggleRatingDiscretion()
      this.listenToAdEvents()
      return
    }

    this.toggleRatingDiscretion()
  }

  initializeAds() {
    this.player.ima({
      id: 'vjs_video_3',
      adTagUrl: `${this.props.videoTag}&vid=${this.props.videoId}` +
        `&url=${window.location.href}&correlator=${new Date().getTime()}` +
        `&cust_params=sd%3D60000%26site%3D${window.location.origin}%26autostart%3D` +
        `%26mute%3D%26user_agent%3D%26keyword%3D%26category%3D${this.props.category}` +
        `%26vid%3D${this.props.videoId}%26categories%3D${this.categories}%26tags%3D${this.tags}`,
      adLabel: 'Your video will resume after this sponsor message'
    })
  }

  listenToAdEvents() {
    this.player.on('adscomplete', this.toggleRatingDiscretion)
    this.player.on('adserror', this.toggleRatingDiscretion)
  }

  toggleRatingDiscretion() {
    if (this.isRatingEnabled() && !this.state.ratingDisplayDone) {
      return this.showRatingDiscretion()
    }
    return this.hideRatingDiscretion()
  }
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // pause video if trailer modal is open
    if (!prevProps.modalOpen && this.props.modalOpen) {
      if (this.player) this.player.pause()

      if (typeof (window.google) !== "undefined" && this.player.ima) {
        _.isFunction(this.player.ima.pause) && this.player.ima.pause()
      }
    } else if (prevProps.modalOpen && !this.props.modalOpen) {
      // this.player.play()
      if (typeof (window.google) !== "undefined")
        _.isFunction(this.player.ima.resume) && this.player.ima.resume()
    }
    if (this.player && !this.state.startedAtSetTime && this.props.startTime) {
      this.player.currentTime(this.props.startTime)
      this.setState({ startedAtSetTime: true })
    }
    if (!prevState.showEmbed && this.state.showEmbed) {
      this.player.pause()
    }
  }

  isRatingEnabled() {
    return (
      (_.get(window.settings, 'user_content_rating', false)) &&
      !this.props.isTrailer &&
      this.parentalRating &&
      this.parentalRating !== 'NR'
    )
  }

  hideRatingDiscretion() {
    this.player.play()
    this.setState({
      showRatingDiscretion: false,
      ratingDisplayDone: true
    })
  }

  showRatingDiscretion() {
    this.player.pause()
    this.setState({ showRatingDiscretion: true })
  }

  updateCaptions(captions) {
    if (this.player && captions) {
      _.map(this.player.remoteTextTrackEls(), (capEl) => {
        this.player.removeRemoteTextTrack(capEl)
      })

      _.map(captions, (caption, index) => {
        this.player.addRemoteTextTrack({
          src: caption.url,
          manualCleanup: true,
          srcLang: caption.language,
          label: caption.language,
        }, true)
      })
    }
  }

  get parentalRating() {
    return this.props.parentalRating || _.get(this.props, 'video.parentalRating')
  }

  render() {
    return (
      <div>
        {this.state.videoEnded &&
          <NextVideoTimer
            backgroundUrl={this.props.video.nextEpisode.videoImageUrl}
            nextVideoTitle={this.props.video.nextEpisode.title}
            timer={3}
            action={this.props.video.playNextEpisode}
          />
        }
        {this.state.videoEnded && this.props.isPlaylistItem && this.props.nextVideoDataAction.nextVideoData.gist &&
          <NextVideoTimer
            backgroundUrl={this.props.nextVideoDataAction.nextVideoData.gist.videoImageUrl}
            nextVideoTitle={this.props.nextVideoDataAction.nextVideoData.gist.title}
            timer={3}
            isPlaylistItem={this.props.isPlaylistItem}
            action={this.props.nextVideoDataAction.playNextAction}
          />
        }
        {this.state.videoWall &&
          <VideoWall
            isEpisode={this.props.isEpisode}
            content={this.props.video}
            videoGist={this.props.video.gist}
          />
        }
        <div data-vjs-player>
          {this.state.showRatingDiscretion &&
            <RatingDiscretion
              hide={this.hideRatingDiscretion.bind(this)}
              rating={this.parentalRating} />
          }
          {this.state.showEmbed && <Embed videoId={this.props.videoId} toggleEmbed={this.toggleEmbed} />}
          {this.state.errorMessage
            ? <div className="error-message"> {this.state.errorMessage} </div>
            : <video
              ref={node => this.videoNode = node}
              className={`video-js` + (this.hasAccess || this.props.isFree ? '' : ' hd-cc')}
            >
            </video>
          }
        </div>
      </div>
    )
  }
}

export default VideoJS